import { Events, FSMCommonTransitions } from '../../constants'
import { ERROR_QUOTE_CONSTRAINTS, ERROR_QUOTE_VALIDATION } from '../../../../constants'
import { StatesConfigType } from '../../config'

const { AUTH_BANK_ID, AUTH, AUTH_BANK_ID_START, MY_PAGES, ERROR } = FSMCommonTransitions

export default (FLOW_MACHINE_ID: string): StatesConfigType => ({
  [AUTH_BANK_ID]: {
    initial: AUTH_BANK_ID_START,
    states: {
      [AUTH_BANK_ID_START]: {
        on: {
          [Events.CUSTOM_AUTH_SUCCESS]: {
            target: `#${FLOW_MACHINE_ID}.${MY_PAGES}`,
            actions: ['setUserAuthorized', 'setBankIdAuth'],
          },
          [Events.CUSTOM_AUTH_FAILURE]: {
            target: `#${FLOW_MACHINE_ID}.${ERROR}`,
          },
          [Events.CUSTOM_AUTH_START]: {
            target: `#${FLOW_MACHINE_ID}.${AUTH_BANK_ID}`,
          },
        },
      },
    },
  },
  [ERROR]: {
    on: {
      [Events.BACK]: [
        {
          target: `${AUTH}`,
          actions: ['signOut', 'switchFlow'],
          guard: ({ context }) => {
            const errorType = context.errorType

            return [ERROR_QUOTE_CONSTRAINTS, ERROR_QUOTE_VALIDATION].includes(errorType as string)
          },
        },
        {
          target: `${AUTH}`,
          actions: ['signOut', 'switchFlow'],
          guard: ({ context }) => {
            const backPath = context.backPath as Record<string, string>

            return !!backPath.bankId
          },
        },
      ],
    },
  },
})
